import {Setting} from "./Setting";

export const magicSetting: Setting = {
    key: "Magic",
    title: "Магия",
    description: "Магия описывает сверхъестественные явления, силы и механики, которые выходят за рамки естественных законов. Она влияет на культуру, общество, экономику и сюжет, создавая уникальную атмосферу и возможности для взаимодействия с миром.",
    components: [
        {
            title: "Источник магии",
            subComponents: [
                {
                    title: "Природный",
                    description: `Энергия, исходящая из природных элементов (огонь, вода, земля, воздух, растения, звезды).`,
                    examples: ["Друиды, использующие силу природы для лечения и защиты."]
                },
                {
                    title: "Божественный",
                    description: `Сила, даруемая богами или высшими сущностями.`,
                    examples: ["Жрецы, получающие магию от божества."]
                },
                {
                    title: "Внутренний",
                    description: `Личная энергия мага, сила души или воли.`,
                    examples: ["Монахи, использующие внутреннюю силу для борьбы с врагами."]
                },
                {
                    title: "Рунический",
                    description: `Магия, заключенная в символах, рунах или глифах.`,
                    examples: ["Гномы, создающие магические устройства с рунами."]
                },
                {
                    title: "Мистический",
                    description: `Энергия из другого измерения, эфира или параллельных миров.`,
                    examples: ["Шаманы, общающиеся с духами и призывающие силы природы."]
                },
                {
                    title: "Артефактный",
                    description: `Сила, заключенная в предметах или реликвиях.`,
                    examples: ["Меч, обладающий огненной магией."]
                },
                {
                    title: "Темный источник",
                    description: `Использование табуированных ресурсов, таких как кровь, души, тени или проклятия.`,
                    examples: ["Некроманты, призывающие духов мертвых."]
                }]
        },
        {
            title: "Типы магии",
            subComponents: [
                {
                    title: "Элементальная",
                    description: `Управление стихиями (огонь, вода, воздух, земля, лед, молния).`,
                    examples: ["Повелители элементов, способные вызывать бури и землетрясения."]
                },
                {
                    title: "Природная",
                    description: `Связь с животными, растениями, погодой.`,
                    examples: ["Друиды, общающиеся с животными и природой."]
                },
                {
                    title: "Ментальная",
                    description: `Чтение мыслей, управление разумом, создание иллюзий.`,
                    examples: ["Телепаты, способные влиять на мысли других."]
                },
                {
                    title: "Целительная",
                    description: `Лечение ран, регенерация, очищение от болезней.`,
                    examples: ["Целители, использующие магию для лечения и восстановления."]
                }, {
                    title: "Некромантия",
                    description: `Управление мертвыми, создание нежити.`,
                    examples: ["Некроманты, воскрешающие мертвых для своих целей."]
                },
                {
                    title: "Трансформация",
                    description: `Изменение формы объектов или существ.`,
                    examples: ["Маги, способные превращаться в животных или других существ."]
                },
                {
                    title: "Заклинательная",
                    description: `Создание магических эффектов через произнесение слов или жестов.`,
                    examples: ["Волшебники, использующие заклинания для вызывания магии."]
                },
                {
                    title: "Ритуальная",
                    description: `Сложные обряды, требующие подготовки и ресурсов.`,
                    examples: ["Шаманы, проводящие ритуалы для вызова духов."]
                },
                {
                    title: "Технологическая магия",
                    description: `Сочетание магии с наукой (маготехника, магопанк).`,
                    examples: ["Инженеры, создающие магические устройства для улучшения жизни."]
                }]
        }, {
            title: "Механика магии",
            subComponents: [
                {
                    title: "Ресурсы",
                    description: `Мана, энергия, очки магии. Жизненная сила, кровь, душа. Временные ограничения (нельзя использовать часто)`,
                    examples: ["Маги, использующие свою жизненную силу для вызова заклинаний."]
                },
                {
                    title: "Сложность",
                    description: `Простая магия доступна большинству. Элитная магия требует долгого обучения или врожденных способностей.`,
                    examples: ["Маги, требующие долгого обучения для вызова сложных заклинаний."]
                },
                {
                    title: "Риск",
                    description: `Обратные эффекты, если магия используется неправильно. сталость, травмы или смерть при чрезмерном использовании. Опасность привлечения демонов, духов или других сущностей.`,
                    examples: ["Маги, подвергающиеся опасности при вызове магии."]
                }]
        }, {
            title: "Влияние магии на общество",
            subComponents: [
                {
                    title: "Повседневная жизнь",
                    description: `Магические устройства и услуги. Простая магия для обычных людей (освещение, лечение).`,
                    examples: ["Магические фонари, освещающие улицы города."]
                },
                {
                    title: "Культура",
                    description: `Магические школы и гильдии. Религии, основанные на магии. Суеверия и страх перед магами.`,
                    examples: ["Магические академии, где обучаются будущие колдуны."]
                },
                {
                    title: "Социальная структура",
                    description: `Разделение общества на магов и не магов. Привилегии для магов или их гонения.`,
                    examples: ["Маги, получающие привилегии в обществе."]
                },
                {
                    title: "Экономика",
                    description: `Использование магии в производстве, сельском хозяйстве, транспорте. Торговля магическими артефактами.`,
                    examples: ["Магические предметы, приносящие прибыль торговцам."]
                }]
        },
        {
            title: "Магические сущности и артефакты",
            subComponents: [
                {
                    title: "Существа",
                    description: `Магические звери (драконы, фениксы, элементали). Духи, демоны, ангелы. Созданные существа (големы, химеры).`,
                    examples: ["Дракон, обитающий в горах."]
                },
                {
                    title: "Артефакты",
                    description: `Оружие, зачарованное магией. Амулеты, защитные обереги. Уникальные предметы с особыми эффектами (книга заклинаний, посох мага).`,
                    examples: ["Меч, способный разрушать заклинания."]
                }]
        },
        {
            title: "Магические законы и ограничения",
            subComponents: [
                {
                    title: "Физические законы",
                    description: `Ограничения на радиус или силу заклинаний. Необходимость изучать магию через книги, учителей.`,
                    examples: ["Магия, вызывающая боли при использовании."]
                },
                {
                    title: "Этические нормы",
                    description: `Запрещенные виды магии (некромантия, темная магия). Последствия за нарушение магических законов.`,
                    examples: ["Магия, приводящая к смерти тех кто ее использует."]
                },
                {
                    title: "Магические барьеры",
                    description: `Антимагия, подавляющие магию зоны. Защита от заклинаний (щит, зачарованные стены).`,
                    examples: ["Зона, где магия не действует."]
                }]
        }
    ],
    prompt: {
        component: {
            list: 'Перечисли возможные компоненты магии и опиши их если они применимы к истории. Не ограничивайся основными компонентами если необходимо',
            single: 'Сгенерируй компонент магии для мира. Опиши ключевые аспекты, механики и последствия магических воздействий.',
            extend: 'Дополни описание компонента магии и разбей на абзацы. Как компонент влияет на мир и персонажей.'
        },
        element: {
            list: 'Перечисли возможные элементы магии и опиши их если они применимы к истории',
            single: 'Сгенерируй элемент магии для мира. Опиши ключевые аспекты, механики и последствия магических воздействий.',
            extend: 'Дополни описание элемента магии и разбей на абзацы. Как элемент влияет на мир и персонажей.'
        },
        lore: {
            list: "Создай элементы лора на основе этого элемента магии. Его историю, мифы, влияние на мир и персонажей",
            single: "Создай элементы лора на основе этого элемента магии. Опиши что-то одно, например: историю, мифы, влияние на мир и персонажей",
            extend: "Дополни описание элемента лора магии и разбей на абзацы."
        }
    }
}